import FooterPricing from "src/components/pricingpersonal/footer";
import Hero from "src/components/pricingpersonal/hero";
import Plans from "src/components/pricingpersonal/plans";

const PricingPersonal = () => {
  return (
    <>
      <div className="mt-20" />
      <Hero />
      <Plans />
      <div className="mt-20" />
      <FooterPricing />
    </>
  );
};

export default PricingPersonal;
